import React from 'react';
import { Col, Row } from '../../grid';
import { isSunday, isSaturday, isToday } from '../../../features/commerce/delivery/dates/shared';
import { Span } from '../../typography';
import TimesSelect from './TimesSelect';


const DateText = ({ date }) => {
  if (isToday(date)) {
    if (isSunday(date)) {
      return (
        <Span fontSize="12px">
          Afhent i weekenden mod gebyr. Kræver telefonisk aftale. Vi ringer dig op når vi har modtaget din ordre.
        </Span>
      );
    }
    if (isSaturday(date)) {
      return (
        <Span fontSize="12px">
          Afhent i weekenden mod gebyr. Kræver telefonisk aftale. Vi ringer dig op når vi har modtaget din ordre.
        </Span>
      );
    }
  }
  if (isSunday(date)) {
    return (
      <Span fontSize="12px">
        Afhent i weekenden mod gebyr. Kræver telefonisk aftale. Vi ringer dig op når vi har modtaget din ordre.
      </Span>
    );
  }
  if (isSaturday(date)) {
    return (
      <Span fontSize="12px">
        Afhent i weekenden mod gebyr. Kræver telefonisk aftale. Vi ringer dig op når vi har modtaget din ordre.
      </Span>
    );
  }
  return null;
};

export default ({
  value,
  onChoose,
  error,
  getTimeFee,
  disabled,
  choices,
  date,
}) => (
  <Row>
    <Col xs={12} paddingTop="0px">
      <TimesSelect
        value={value}
        onChange={({ target: { value } }) => onChoose(value)}
        error={error}
        disabled={disabled}
      >
        {choices.map(
          value => <option value={value} key={value}>{getTimeFee(value)}</option>,
        )}
      </TimesSelect>
      <DateText date={date} />
    </Col>
  </Row>
);
